
import * as React from 'react';
import { IconButton, Button, TextField, Grid, Paper, Typography } from '@material-ui/core';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Clear from '@material-ui/icons/Clear';
import { blueGrey, green, red, orange } from '@material-ui/core/colors';

interface OwnProps {
  status: string;
  onLaunch: ( operationKey: string ) => void;
  onStop: ( operationKey: string ) => void;
  message: string;
  hasError: boolean;
}
interface OwnState {
  open: boolean;
  operationKey: string;
}
class EndpointControl extends React.Component<OwnProps, OwnState>{
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      operationKey: ''
    };
  }

  /**
   * 操作部の開閉
   */
  toggle() {
    if (this.state.open) {
      this.setState({ open: false });
    } else {
      this.setState({ open: true });
    }
  }

  /**
   * EndpointStatusに応じた状態表示文字列を取得する
   */
  statusLabelElement() {
    let label = '';
    let color = orange[700];
    switch(this.props.status) {
      case 'InService':
        label = 'AIサービス稼働中';
        color = green[700];
        break;
      case 'deleted':
        label = 'AIサービス停止中';
        color = red[500];
        break;
      case 'creating':
        label = 'AIサービス起動処理中．．．';
        break;
      case 'deleting':
        label = 'AIサービス停止処理中．．．';
        break;
      default:
        label = this.props.status;
    }
    return (
      <span
        style={{
          color
        }}
      >
        { label }
      </span>
    );
  }

  /**
   * 起動処理を上位に通知。
   * ボタン制御のため30秒間だけprocessingをtrue
   * に設定する
   */
  launch() {
    this.props.onLaunch(this.state.operationKey);
  }
  /**
   * 停止処理を上位に通知。
   * ボタン制御のため30秒間だけprocessingをtrue
   * に設定する
   */
  stop() {
    this.props.onStop(this.state.operationKey);
  }

  render() {
    // 起動ボタンを利用可能なのはstatusがdeletedで操作キーが入力されているときのみ
    const enableLaunch = this.props.status === 'deleted' && this.state.operationKey ;
    // 停止ボタンを利用可能なのはstatusがInServiceで操作キーが入力されているときのみ
    const enableStop = this.props.status === 'InService' && this.state.operationKey ;
    return (
          <div
          >
            { this.statusLabelElement() }
            <IconButton
              onClick={() => this.toggle()}
            >
              {
                this.state.open
                 ? (<Clear fontSize="small" />)
                 : (<KeyboardArrowDown fontSize="small" />)
              }
            </IconButton>
            <Paper
              style={{
                display: this.state.open ? 'block' : 'none',
                padding: '5px',
                backgroundColor: blueGrey[100]
              }}
            >
              <Grid container spacing={8}
                alignItems="flex-end"
              >
                <Grid item sm={4} xs={12}>
                  <TextField
                    label="操作キー"
                    fullWidth
                    onChange={e => this.setState({ operationKey: e.target.value })}
                  />
                </Grid>
                <Grid item sm={8} xs={12}>
                  <Button
                    variant="contained"
                    size="small"
                    disabled={!enableLaunch}
                    onClick={() => this.launch()}
                  >
                    起動
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    disabled={!enableStop}
                    onClick={() => this.stop()}
                  >
                    停止
                  </Button>
                </Grid>
                {
                  this.props.message
                    ? (
                      <Grid item xs={12}>
                        <Typography
                          style={ this.props.hasError ? { color: 'red' } : undefined}
                        >{this.props.message}</Typography>
                      </Grid>
                    )
                    : null
                }
              </Grid>
            </Paper>
          </div>
      );
  }
}
export default EndpointControl;






// WEBPACK FOOTER //
// ./src/components/parts/EndpointControl.tsx